import * as React from "react";
const NoBidsHammer = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={128}
    height={90}
    viewBox="0 0 128 90"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.920898 72.5355L57.9582 44.0532L62.443 53.5305L5.57396 82.2125L0.920898 72.5355Z"
      fill="#7B0100"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M52.3193 25.4706L83.0282 9.7876L85.0273 14.1465L54.4862 30.0354L52.3193 25.4706Z"
      fill="#7B0100"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M72.5674 64.5848L103.276 49.5044L105.275 53.6965L74.7333 68.9734L72.5674 64.5848Z"
      fill="#7B0100"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M48.6054 17.7612L79.7254 2.3375C81.308 1.55286 83.4653 2.17483 84.0256 3.82368L84.0261 3.82501C84.5859 5.47431 84.0932 7.26152 82.5119 8.04528L51.3914 23.4689C49.8101 24.2527 47.6515 23.6329 47.0917 21.9828L47.0912 21.9814C46.5309 20.3312 47.0228 18.5458 48.6054 17.7612Z"
      fill="#7B0100"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M75.8248 70.7162L106.297 55.2927C107.846 54.508 109.959 55.1295 110.507 56.7788L110.508 56.7802C111.056 58.429 110.573 60.2167 109.025 61L78.5532 76.424C77.0049 77.2078 74.8912 76.588 74.3426 74.9378L74.3422 74.9361C73.794 73.2863 74.2756 71.5009 75.8248 70.7162Z"
      fill="#7B0100"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M70.3576 83.77H123.837C125.621 83.77 127.08 85.1719 127.08 86.8851V90.0001H67.1152V86.8851C67.1152 85.1719 68.5741 83.77 70.358 83.77H70.3576Z"
      fill="#7B0100"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M72.6285 79.8774H122.346C123.238 79.8774 123.966 80.7538 123.966 81.8241V83.7712H71.0098V81.8241C71.0098 80.7533 71.7381 79.8774 72.6281 79.8774H72.6285Z"
      fill="#7B0100"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M53.0977 32.1618L69.4942 64.3007L103.717 47.466L87.1327 15.2388L53.0977 32.1618Z"
      fill="#7B0100"
    />
    <path
      d="M42.3243 22.6408L32.9418 27.4271C31.9707 27.9224 30.7847 27.4661 30.3962 26.4477L30.381 26.4081C29.9776 25.3509 30.6191 24.1842 31.728 23.9585L42.0505 21.8583C42.5279 21.7612 42.7579 22.4196 42.3243 22.6408Z"
      fill="#7B0100"
    />
    <path
      d="M44.8774 14.8254L41.9562 5.91814C41.6538 4.9964 42.2179 4.01608 43.1667 3.81413L43.2037 3.80622C44.1889 3.5967 45.1268 4.32092 45.1729 5.32702L45.6031 14.6923C45.623 15.1251 45.0125 15.2371 44.8774 14.8254Z"
      fill="#7B0100"
    />
    <path
      d="M41.3913 17.4695L32.1519 13.0531C31.1957 12.596 30.8474 11.4107 31.4041 10.509L31.4258 10.474C32.0038 9.53783 33.2837 9.34388 34.1132 10.0667L41.834 16.796C42.1907 17.107 41.8183 17.6736 41.3913 17.4695Z"
      fill="#7B0100"
    />
  </svg>
);
export default NoBidsHammer;
